<template>
  <div class="table" ref="tableRef">
    <artmisads-table :columns="columns" row-key="id" :data-source="props.dataList" :pagination="{
      total: props.listTotal,
      current: props.params.page,
      pageSize: props.params.size,
      showSizeChanger: true
    }" :scroll="{ x: 2200, y: tableScrollHeight }" :change="onChangePage" tableLayout="fixed">
      <template #bodyCell="{ column, record, text }">
        <template v-if="column.name === 'showCurrency'">
          {{ AMAZON_CURRENCY_MAPPER[record.marketplace] }}{{ text }}
        </template>
        <template v-if="column.name === 'amount' && record.billingType !== 'MONTHLY'">
          <div :class="text ? text > 0 ? 'amount-plus' : 'amount-minus' : ''">
            {{ setUnit(text) }} {{ text || text == 0 ? AMAZON_CURRENCY_MAPPER[record.marketplace] : '' }}{{ setAmount(text) }}
          </div>

        </template>
        <template v-if="column.name === 'amount' && record.billingType === 'MONTHLY'">
          {{ text || text == 0 ? AMAZON_CURRENCY_MAPPER[record.marketplace] : '--' }}{{ text }}
        </template>

        <template v-if="column.name === 'status'">
          {{ FINANCE_PAYMENT_DETAIL_STATUS_MAP[text]?.label }}
        </template>
        <template v-if="column.name === 'sellerPayStatus'">
          {{ FINANCE_SELLER_PAYMENT_STATUS_MAP[text]?.label }}
        </template>
        <template v-if="column.name === 'displayStatus'">
          {{ text === 'Declined' ? 'N/A' : text }}
        </template>
        <template v-if="column.name === 'account'">
          <div class="seller-name">
            <span>{{ record.publisherName }}</span>
            <span>{{ record.publisherEmail }}</span>
          </div>
        </template>
        <template v-if="column.name === 'transactionCycleStartDate'">
          {{ record.transactionCycleStartDate }} - {{ record.transactionCycleEndDate }}
        </template>
        <template v-if="column.name === 'actions'">
          <div class="actions">
            <!-- v-if="record.sellerPayStatus == 'paid' && (record.status == 'not_paid'||record.status == 'declined') && record.paidAmount == '0' -->
            <template v-if="record.sellerPayStatus == 'paid' && (record.status == 'not_paid'||record.status == 'declined') && record.paidAmount == '0'">
              <artmisads-select-button class="decline-btn" @click="() => toDeclined(record.billingId)" size="small"
                v-if="record.displayStatus !== 'Declined'">Set N/A</artmisads-select-button>
              <artmisads-select-button class="decline-btn" @click="() => toUnDoDeclined(record.billingId)" size="small"
                v-if="record.displayStatus === 'Declined'">Undo Set N/A</artmisads-select-button>
            </template>

            <artmisads-select-button @click="() => toDetail(record.billingId)" size="small"
              v-if="props.status !== 'paid'">Edit</artmisads-select-button>
            <artmisads-select-button @click="() => openHistory(record.billingId)"
              size="small">History</artmisads-select-button>
            <artmisads-select-button @click="() => setShowPaymentDetailModal(true, record.billingId, record.billingType)"
              size="small">Details</artmisads-select-button>
          </div>
        </template>
      </template>
    </artmisads-table>
  </div>
</template>
<script lang="jsx" setup>
import { useRouter } from "vue-router"
import moment from 'moment'
import { ref, computed } from 'vue'
import { message, Modal } from "ant-design-vue"

import { AMAZON_CURRENCY_MAPPER } from '~/contants/common'
import { FINANCE_PAYMENT_DETAIL_STATUS_MAP, FINANCE_SELLER_PAYMENT_STATUS_MAP } from '~/contants/operator'
import { useTableScrollHeight } from "@/utils/useTableScrollHeight"
const router = useRouter()
const tableRef = ref(null)
const props = defineProps(['setShowPaymentDetailModal', 'listTotal', 'setParams', 'params', 'dataList', 'getList', 'status', 'setBillingId', 'setShowHistoryModal', 'setShowPaymentModal', 'toDeclined', 'toUnDoDeclined'])
const setBillingType = (value) => {
  if (value === undefined || value === null) return ''
  const str = String(value).toLowerCase()
  return str.charAt(0).toUpperCase() + str.slice(1)
}
const hasPaidDisplayStatus = (status) => {
  if (!status) return false
  const text = String(status)
  return text.includes('Paid') && !text.includes('Not Paid')
}
const columns = computed(() => {
  return props.status === 'pending' ?
    [
      {
        title: 'Payment ID',
        dataIndex: 'billingId',
        width: 200,
      },
      {
        title: 'ArtemisAds Account',
        dataIndex: 'ArtmisAds',
        width: 120,
        name: 'account',
      },

      {
        title: 'Amount',
        dataIndex: 'amount',
        width: 200,
        name: 'amount',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        name: 'status',
        width: 140,
      },
    ] : [
      {
        title: 'Payment ID',
        dataIndex: 'billingId',
        width: 200,
        fixed: 'left',
      },
      {
        title: 'ArtemisAds Account',
        dataIndex: 'ArtmisAds',
        width: 180,
        name: 'account',
      },
      {
        width: 120,
        title: 'Type',
        dataIndex: 'billingType',
        name: 'billingType',
        customRender: ({ text, record }) => {
          return setBillingType(record.billingType)
        }
      },
      {
        title: 'Amount',
        dataIndex: 'amount',
        width: 200,
        name: 'amount',
      },
      {
        title: 'Seller Payment Status',
        dataIndex: 'sellerPayStatus',
        name: 'sellerPayStatus',
        width: 180,
      },
      {
        title: 'Seller Pending To Pay',
        dataIndex: 'pendingAmount',
        width: 200,
        name: 'amount',
      },
      {
        title: 'Ready To Pay Publisher',
        dataIndex: 'readyToPayAmount',
        width: 150,
        name: 'amount',
      },
      {
        title: 'Paid To Publisher',
        dataIndex: 'paidAmount',
        width: 140,
        name: 'amount',
      },
      {
        title: 'Publisher Finance Approval Status',
        dataIndex: 'bankInformationReviewStatus',
        name: 'bankInformationReviewStatus',
        width: 160,
      },
      {
        title: 'Artemis Payment Status for Publisher',
        dataIndex: 'displayStatus',
        name: 'displayStatus',
        width: 180,
      },
      {
        title: 'Actions',
        dataIndex: 'id',
        name: 'actions',
        width: 400,
        fixed: 'right',
      },
    ]
})

const onChangePage = (data, filters, sorter) => {
  const { current, pageSize } = data
  let newParams = { ...props.params }
  newParams.page = current
  newParams.size = pageSize
  if (sorter) {
    const { field, order } = sorter
    newParams.sortField = field
    newParams.sortDirection = order === 'ascend' ? 'asc' : 'desc'
  } else {
    newParams.sortField = ''
    newParams.sortDirection = ''
  }
  props.setParams(newParams)
  props.getList()
}
const setUnit = (record) => {
  if (record || record == 0) {
    if (record > 0) {
      return '+'
    }
    else if (record == 0) {
      return ''
    }
    else {
      return '-'
    }
  }
  else {
    return ''
  }
}
const setAmount = (record) => {
  if (record || record == 0) {
    return Math.abs(record)
  }
  else {
    return '--'
  }
}
const openHistory = id => {
  props.setBillingId(id)
  props.setShowHistoryModal(true)
}

const toDetail = id => {
  props.setBillingId(id)
  props.setShowPaymentModal(true)
}
const toDeclined = id => {
  Modal.confirm({
    title: 'Notice',
    content: 'Are you sure to Set N/A this payment ?',
    okText: 'Yes',
    cancelText: 'No',
    onOk: () => {

      props.toDeclined(id)
    },
  })
}

const toUnDoDeclined = id => {
  Modal.confirm({
    title: 'Notice',
    content: 'Are you sure to undo Set N/A this payment ?',
    okText: 'Yes',
    cancelText: 'No',
    onOk: () => {

      props.toUnDoDeclined(id)
    }
  })

}
const { tableScrollHeight } = useTableScrollHeight({
  selector: '.table',
  bottomSpace: 250,
  minHeight: 200,
  maxHeight: 1000,
  defaultHeight: 350
})
</script>
<style lang="less" scoped>
.amount-plus {
  color: #FF0000;
}

.amount-minus {
  color: #2AAE67;
}

.table {
  padding: 16px 0;

  :deep(.ant-tooltip-arrow) {
    display: none;
  }

  :deep(.ant-table) {
    .ant-table-thead {
      .ant-table-cell {
        line-height: 24px;
      }
    }

    .seller-name {
      display: flex;
      flex-direction: column;

      >span {
        &:first-child {
          font-weight: 600;
          margin-bottom: 2px;
        }
      }
    }

    .actions {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: 8px;

      button {
        flex-shrink: 0;
        margin-left: 0;
      }

      .confirm-btn {
        color: var(--primary-text);
        border-color: #fff;
        box-shadow: none;
      }

      .decline-btn {
        background: var(--dark-1);
        color: #fff;
        border-color: var(--dark-1);

        &:hover,
        &:focus {
          background: var(--dark-1);
          color: #fff;
          border-color: var(--dark-1);
        }
      }
    }

    .ant-table-cell-fix-right,
    .ant-table-cell-fix-left {
      overflow: hidden;
    }
  }
}
</style>